import * as t from '../types';
import {GET_HOLIDAYS_REQUEST, GET_TUTOR_ONE_2_ONE_REQUEST, POST_HOLIDAYS_REQUEST} from "../types";

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function postMailChimpReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.POST_MAILCHIMP_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.POST_MAILCHIMP_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.POST_MAILCHIMP_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
